import { useCallback, useMemo, useState } from 'react';
import moment, { Moment } from 'moment';
import { ModelWithValuationData } from 'dashboard409a/services/models.types';

/**
 * Calculates a date that is N business days from today.
 * Business days exclude weekends (Saturday and Sunday).
 * @param businessDays - Number of business days to add (default: 4)
 * @returns Date string in YYYY-MM-DD format
 */
export const addBusinessDays = (date?: Date | Moment | string, days: number = 4): string => {
  let result = moment(date || new Date());
  let daysAdded = 0;

  while (daysAdded < days) {
    result = result.add(1, 'days');
    
    if (result.day() !== 0 && result.day() !== 6) {
      daysAdded += 1;
    }
  }

  return result.format('YYYY-MM-DD');
}

export const useOperationsModal = ({ models }: { models: ModelWithValuationData[] }) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedModelId, setSelectedModelId] = useState<number | undefined>();

  // Derive the selected model from models reactively
  const selectedModel = useMemo(() => {
    if (!selectedModelId) {
      return undefined;
    }
    return models.find(
      model => model.id === selectedModelId || model.company_measurement_date === selectedModelId
    );
  }, [models, selectedModelId]);

  const handleOpenModal = useCallback((model: ModelWithValuationData) => {
    // Store the ID or company_measurement_date as identifier
    setSelectedModelId(model.id || model.company_measurement_date);
    setOpenModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setSelectedModelId(undefined);
  }, []);

  return {
    openModal,
    selectedModel,
    handleOpenModal,
    handleCloseModal,
  };
};

